"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Forms/Editor/AskAdmin.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }/* Ask an admin to publish (screen 10): pick an org admin and send the request. */
var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _Form = require('web/components/Form');









 const userName = (u) =>
  u ? (u.Name || `${u.FirstName} ${u.LastName}`.trim()) : ''; exports.userName = userName

const AskAdmin = ({ admins, isSending, onSend, onClose }) => {
  const [picked, setPicked] = _react.useState(null)
  const ref = _react.useRef(null)

  _react.useEffect.call(void 0, () => {
    const onDown = (e) => {
      if (ref.current && !ref.current.contains(e.target )) onClose()
    }
    const onKey = (e) => { if (e.key === 'Escape') onClose() }
    document.addEventListener('pointerdown', onDown)
    document.addEventListener('keydown', onKey)
    return () => {
      document.removeEventListener('pointerdown', onDown)
      document.removeEventListener('keydown', onKey)
    }
  }, [onClose])

  return (
    _react2.default.createElement('div', { ref: ref, className: "forms-editor--popover", role: "dialog", 'aria-label': "Ask an admin to publish"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}}
      , _react2.default.createElement('h2', { className: "forms-editor--popover-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}, "Ask an admin to publish"    )
      , _react2.default.createElement('p', { className: "forms-editor--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}}, "Only org admins can publish. BloomText sends the admin you pick a message with a link to this draft."

      )
      , _react2.default.createElement('div', { role: "radiogroup", 'aria-label': "Org admin" , className: "forms-editor--admins", __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}
        ,  admins === null && _react2.default.createElement('p', { className: "forms-editor--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}, "Loading admins…" ) 
        ,  _optionalChain([admins, 'optionalAccess', _ => _.length]) === 0 && _react2.default.createElement('p', { className: "forms-editor--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}, "This org has no admins yet."     ) 
        ,  _optionalChain([admins, 'optionalAccess', _2 => _2.map, 'call', _3 => _3(a => (
          _react2.default.createElement('button', {
            key: a.UserKey,
            type: "button",
            role: "radio",
            'aria-checked': picked === a.UserKey,
            className: _classBuilder2.default.call(void 0, 'forms-editor--admin', picked === a.UserKey && 'forms-editor--admin--on'),
            onClick: () => setPicked(a.UserKey), __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}

            , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 54}},  exports.userName.call(void 0, a) )
            , _react2.default.createElement('span', { className: "forms-editor--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 55}}, "Org admin" )
          )
        ))])
      )
      , _react2.default.createElement('div', { className: "forms-editor--popover-actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}
        , _react2.default.createElement(_Form.Button, { isDisabled: !picked, isLoading: isSending, onClick: () => picked && onSend(picked), __self: this, __source: {fileName: _jsxFileName, lineNumber: 60}}, "Send request"

        )
      )
    )
  )
}

exports. default = AskAdmin
